<div>
	<app-header [journeyStep]="step()" (up)="onUp()" (onBack)="onBackClick()" [useOnBack]="true" #header></app-header>

	<div class="fade-in">
		<div class="breadcrumbs">
			@if (!isHighestRoleStudent()) {
				<div (click)="navigateToDashboard()">Reports</div>
				@if (selectedProduct()) {
					<div (click)="selectProduct(undefined)">&nbsp;/ {{ selectedProduct()!.name }}</div>
				}
				@if (selectedLocation()) {
					<div (click)="selectLocation(undefined)">&nbsp;/ {{ selectedLocation()!.name }}</div>
				}
				@if (selectedSection()) {
					<div (click)="selectSection(undefined)">&nbsp;/ {{ selectedSection()!.name }}</div>
				}
				@if (selectedSection() && selectedStudentUuid()) {
					<span class="fade-in-with-delay" (click)="selectSection(selectedSection())">
						&nbsp;/ {{ selectedStudentUuid() | displayName: 'user' | async }}
					</span>
				}
			}
			@if (loading()) {
				<div class="loading-spinner">
					<nz-spin nzSimple nzSize="small"></nz-spin>
				</div>
			}
		</div>

		@switch (selectedProduct()?.engine_name) {
			@case (Engines.STRIDE) {
				@switch (state()) {
					@case (ReportState.STRIDE_DISTRICT_REPORT) {
						<app-stride-district-report></app-stride-district-report>
					}
					@case (ReportState.STRIDE_SCHOOL_REPORT) {
						<app-stride-school-report></app-stride-school-report>
					}
					@case (ReportState.STRIDE_SECTION_REPORT) {
						<app-stride-section-report></app-stride-section-report>
					}
					@case (ReportState.STRIDE_STUDENT_REPORT) {
						<app-stride-student-report></app-stride-student-report>
					}
					@default {
						@if (!loading()) {
							<h1>Missing required permissions</h1>
						}
					}
				}
			}
			@case (Engines.JOURNEY) {
				@switch (state()) {
					@case (ReportState.JOURNEY_DISTRICT_REPORT) {
						<app-journey-district-report></app-journey-district-report>
					}
					@case (ReportState.JOURNEY_SCHOOL_REPORT) {
						<app-journey-school-report></app-journey-school-report>
					}
					@case (ReportState.JOURNEY_SECTION_REPORT) {
						<app-journey-section-report></app-journey-section-report>
					}
					@case (ReportState.JOURNEY_STUDENT_REPORT) {
						<app-journey-student-report></app-journey-student-report>
					}
					@default {
						@if (!loading()) {
							<h1>Missing required permissions</h1>
						}
					}
				}
			}
			@default {
				@if (state() === ReportState.STUDENT_SECTION_SELECTOR && !selectedStudentUuid()) {
					@if (!loading()) {
						<app-student-section-selector
							(onSectionSelected)="onStudentSelectedSection($event)"
						></app-student-section-selector>
					}
				} @else {
					@if (!loading()) {
						<div>
							<app-products (onSelectProduct)="selectProduct($event)"></app-products>
						</div>
					}
				}
			}
		}
	</div>
</div>
